import { NavHeader, SubPage } from './nav-header';
import { CompaniesDropDown } from './companies-dropdown';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/configure-store';

interface PageNavBarProps {
    mainPage: string
}

const globalPages: SubPage[] = [
    { label: 'Objectives', route: 'objectives' },
    { label: 'Systems', route: 'systems' },
    { label: 'Companies', route: 'companies' },
]

const companyPages: SubPage[] = [
    { label: 'Audit Controls', route: 'audit-controls' },
    { label: 'Entities', route: 'entities' },
    { label: 'Entity Systems', route: 'entity-systems' },
    { label: 'Users', route: 'employees' },
]

const awsPages: SubPage[] = [
    { label: 'ETL Schedules', route: 'glue-triggers' },
]

const formPages: SubPage[] = [
    { label: 'Add Audit Control', route: 'add-audit-control' },
]

export const PageNavBar: React.FC<PageNavBarProps> = ({ mainPage }) => {
    const companies = useSelector((state: RootState) => state.companies.value)

    if (mainPage === 'aws') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__top' />
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={awsPages} preserveCompany={false} />
                </div>
            </div>
        )
    }

    if (mainPage === 'forms') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={formPages} />
                </div>
            </div>
        )
    }

    if (mainPage === 'company') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__top'>
                    <CompaniesDropDown companies={companies} />
                </div>
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={companyPages} />
                </div>
            </div>
        )
    }

    return (
        <div className='page-nav-area'>
            <div className='page-nav-area__top' />
            <div className='page-nav-area__tabs'>
                <NavHeader subPages={globalPages} preserveCompany={false} />
            </div>
        </div>
    );
}
